import { createFeatureSelector, createSelector } from '@ngrx/store';

import { Session } from '@app/store/models/session.model';
import { AccessItem } from '@app/store/models/access-item.model';
import { ApplicationInitStatus } from '@angular/core';

// import { SettingsState } from '../settings/settings.state';


export interface App {
    session: Session;
    version: AppVersion;
    status: AppStatus;
    settings: any;
}

export interface AppVersion {
    hash: string,
    checked: Date,
    changed: boolean
}

export interface AppStatus {
    value: string,
    checked: Date
}

export const AppStatusValues = {
    OK: "ok",
    VERSION_CHANGED: "version_changed",
    DISCONNECTED: "disconnected"
}

export const initialState: App = {
    session: null,
    version: {
        hash: null,
        checked: new Date(),
        changed: false
    },
    status: {
        value: AppStatusValues.OK,
        checked: new Date()
    },
    settings: null,
};

const appFeatureSelector = createFeatureSelector('app');

export const appSelector = createSelector(
    appFeatureSelector,
    (state: App) => state
);

export const appSessionSelector = createSelector(
    appFeatureSelector,
    (state: App) => state.session
);

export const appSessionOrganizationSelector = createSelector(
    appFeatureSelector,
    (state: App) => state.session.current.organization
);

export const appVersionSelector = createSelector(
    appFeatureSelector,
    (state: App) => state.version
);

export const appStatusSelector = createSelector(
    appFeatureSelector,
    (state: App) => state.status
);

/**
 * Get boolean access to a plugin by its string name
 * @param plugin the name of the plugin access to check
 * @returns either true/ false depending on plugin is included or not
 */
export const appPluginsAccessSelector = (plugin: string) => createSelector(
    appFeatureSelector,
    (state: App) => state.session?.options?.plugins.some((pa: string) => pa === plugin)
);

/**
 * Get access value on app by its string name
 * @param access the name of the specific access to check
 * @returns either true/ false / string depending on access given
 */
export const appAccessSelector = (accessKey: string) => createSelector(
    appFeatureSelector,
    (state: App) => state.session?.options?.access.hasOwnProperty(accessKey) ? state.session?.options?.access[accessKey] : true
);
